/**
 * a generic method to handle errors including server side errors.*
 * @param error - axios error object
 * @returns string
 */
const handleError = (error: any): string => {
  let httpError: string = 'An unknown error occurred. Please try again later.'
  if (error.response) {
    if (error.response.status >= 500) {
      httpError = 'Server error. Please try again later.'
    } else if (error.response.data?.error) {
      httpError = error.response.data.error
    } else if (error.response.data?.message) {
      httpError = error.response.data.message
    }
  } else if (error.status === 200) {
    httpError = error.data?.error
  }
  return httpError
}

export { handleError }
